/** API route map: URLS.Controller.JobRequestStatuses */
export const JobRequestStatuses = {
      Name: 'JobRequestStatus/',
      GetAll: 'get-all',
};
